<template>
<!--我的资料下载-->
  <div id="mymaterial">
    <h2 class="title">
      <a href="" class="prev"></a>
      资料下载
    </h2>
    <div class="course">
      <h3>2022下 |《保教知识与能力》基础课</h3>
      <ul class="main">
        <li>
          <div class="left">
            <h5>模块二 第1-2章</h5>
            <p>1M</p>
          </div>
          <div class="right">
            打开
          </div>
        </li>
      </ul>
    </div>
    <div class="course">
      <h3>2022下 |《保教知识与能力》基础课</h3>
      <ul class="main">
        <li>
          <div class="left">
            <h5>模块二 第1-2章</h5>
            <p>1M</p>
          </div>
          <div class="right">
            打开
          </div>
        </li>
        <li>
          <div class="left">
            <h5>模块二 第1-2章</h5>
            <p>1M</p>
          </div>
          <div class="right">
            打开
          </div>
        </li>
        <li>
          <div class="left">
            <h5>模块二 第1-2章</h5>
            <p>1M</p>
          </div>
          <div class="right">
            打开
          </div>
        </li>
      </ul>
    </div>
    <div class="bg"></div>
  </div>
</template>

<script>
export default {
  name: 'MyMaterial',
  data () {
    return {
      materialData: {}
    }
  },
  methods: {
    getMaterial () {
      let data = {
        page: 1,
        length: 100
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_user_all_courseware',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.materialData = res.data.data
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  mounted () {
    this.getMaterial()
  }
}
</script>

<style scoped lang="stylus">
  #mymaterial
    .title
      position: relative
      height: 1.08rem
      line-height: .8rem
      background-color: transparent
      padding: .14rem .16rem
      font-size: .32rem
      color: #050505
      font-weight: 600
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        display: block
        width: .8rem
        height: .8rem
        background-color: #fff
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #050505
          border-bottom: .03rem solid #050505
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
    .course
      h3
        position: relative
        line-height: 1.24rem
        padding: 0 .4rem
        font-size: .32rem
        color: #292929
        font-weight: 600
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        &::before
          content: ""
          position: absolute
          top: .48rem
          left: 0
          display: block
          width: .08rem
          height: .28rem
          background-color: #FF7052
      ul.main
        background-color: #fff
        padding: 0 .4rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        li
          display: flex
          justify-content: space-between
          align-items: center
          height: 1.32rem
          background: url(../../assets/icon/mymaterial_icon_pdf.png) no-repeat left center
          -webkit-background-size: .58rem .68rem
          background-size: .58rem .68rem
          padding: 0 0 0 .8rem
          border-bottom: .02rem solid #CFD1D4
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          .left
            h5
              font-size: .32rem
              color: #292929
              font-weight: 600
            p
              font-size: .22rem
              color: #9DA4B3
          .right
            height: .8rem
            padding: .5rem 0 0
            background: url(../../assets/icon/mymaterial_icon_open.png) no-repeat center top
            -webkit-background-size: .44rem
            background-size: .44rem
            font-size: .24rem
            color: #9DA4B3
            text-align: center
            -webkit-box-sizing: border-box
            -moz-box-sizing: border-box
            box-sizing: border-box
          &:last-child
            border: none
    .bg
      position: fixed
      top: 0
      left: 0
      z-index: -1
      width: 100%
      height: 100%
      background-color: #F7F7F7
</style>



// WEBPACK FOOTER //
// src/components/personal/MyMaterial.vue